(() => {
  const footers = document.querySelectorAll('[data-seq-footer]');

  if (!footers.length) return;

  footers.forEach((footer) => {
    const groups = Array.from(footer.querySelectorAll('[data-footer-group]'));
    const mobileQuery = window.matchMedia('(max-width: 640px)');

    const setGroupState = (group, open) => {
      const toggle = group.querySelector('[data-footer-toggle]');

      group.classList.toggle('is-open', open);

      if (toggle) {
        toggle.setAttribute('aria-expanded', String(open));
      }
    };

    const syncLayout = () => {
      groups.forEach((group, index) => {
        setGroupState(group, mobileQuery.matches ? index === 0 : true);
      });
    };

    groups.forEach((group) => {
      const toggle = group.querySelector('[data-footer-toggle]');

      if (!toggle) return;

      toggle.addEventListener('click', () => {
        if (!mobileQuery.matches) return;

        const willOpen = !group.classList.contains('is-open');

        groups.forEach((otherGroup) => {
          setGroupState(otherGroup, false);
        });

        setGroupState(group, willOpen);
      });
    });

    if (typeof mobileQuery.addEventListener === 'function') {
      mobileQuery.addEventListener('change', syncLayout);
    } else {
      mobileQuery.addListener(syncLayout);
    }

    syncLayout();
  });
})();
